<template>
    <main>
        <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>
        <div class="row">
            <form @submit.prevent="onSubmit">
                <div class="col l4 input-field" style="margin-top:37px;">
                    <i class="material-icons prefix">search</i>
                    <input type="text" id="autocomplete-input" class="autocomplete" ref="autocompleteIndicadores">
                    <label for="autocomplete-input">Indicador</label>
                </div>
                <div class="col l2 input-field" style="margin-top:37px;">
                    <input id="valor" v-model="valor" type="text" class="validate">
                    <label for="valor" class="active">Valor</label>
                </div>
                <div class="col l2 input-field">
                    <inncosys-select v-model="periodo" :data-set-ready="true" first-option-message="Selecciona un periodo" label="Periodo">
                        <option value="M">Mensual</option>
                        <option value="W">Semanal</option>
                        <option value="D">Diario</option>
                    </inncosys-select>
                </div>
                <div class="col l2 input-filed" style="margin-top:15px;">
                    <inncosys-date-picker label="Fecha" v-model="fecha" :options="{autoClose: true, defaultDate:new Date(), setDefaultDate:true}" :verror="'Por favor selecciona la fecha'">

                    </inncosys-date-picker>
                    <small>Periodo Calculado del objetivo: {{firstday}} al {{lastday}}</small>
                </div>
                <div class="col l2 input-field">
                    <br>
                    <button class="btn" type="submit">Ingresar Meta</button>
                </div>
            </form>

        </div>
        <div class="row">
            <div class="col l12 ">
                <div>
                    <div v-if="loadingResults" class="progress">
                        <div class="indeterminate"></div>
                    </div>
                    <datatable title="Resultados Indicadores" :columns="columns" :rows="rows"></datatable>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import Breadcrumbs from '../../components/commun/Breadcrumbs.vue';
import DatePicker from '../../components/commun/forms/DatePicker.vue';
import Select from '../../components/commun/forms/Select.vue';
import DataTable from 'vue-materialize-datatable';
import * as firebase from 'firebase';

const moment = require('moment');

export default {
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysDatePicker: DatePicker,
    inncosysSelect: Select,
    datatable: DataTable,
  },
  data() {
    return {
      fecha: new Date(),
      indicadorSeleccionado: '',
      indicadorSeleccionadoNombre: '',
      firstdayLong: 0,
      lastdayLong: 0,
      firstday: '',
      lastday: '',
      valor: 0,
      periodo: '',
      indicadoresAutocompleteKeys: {},
      loadingResults: false,
      pathHistory: [
        {
          name: 'Inicio',
          route: '/',
        },
        {
          name: 'Metas',
          route: '/metas',
        },
      ],
      columns: [
        {
          label: 'Nombre', // Column name
          field: 'nombre', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Valor', // Column name
          field: 'valor', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Periodo', // Column name
          field: 'periodo', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Fecha Inicial', // Column name
          field: 'fechaIni', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Fecha Final', // Column name
          field: 'fechaFin', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
      ],
      rows: [],
    };
  },

  methods: {
    onSubmit() {
      const vueInstance = this;
      firebase
        .database()
        .ref('metas')
        .push()
        .set({
          indicador: vueInstance.indicadorSeleccionado,
          valor: this.valor,
          periodo: this.periodo,
          fechaIni: this.firstday,
          fechaFin: this.lastday,
          fechaIniLong: this.firstdayLong,
          fechaFinLong: this.lastdayLong,
          nombre: this.indicadorSeleccionadoNombre,
        });
    },
    obtenerMetas() {
      const vueInstance = this;
      firebase
        .database()
        .ref('metas')
        .on('value', (metasSnapshot) => {
          vueInstance.rows = [];
          console.log(metasSnapshot.val(), 'META');
          metasSnapshot.forEach((metaSnapshot) => {
            vueInstance.rows.push({
              indicador: metaSnapshot.val().indicador,
              periodo: metaSnapshot.val().periodo,
              valor: metaSnapshot.val().valor,
              nombre: metaSnapshot.val().nombre,
              fechaIni: metaSnapshot.val().fechaIni,
              fechaFin: metaSnapshot.val().fechaFin,
            });
          });
        });
    },
    insertarIndicador() {
      firebase
        .database()
        .ref('indicadores')
        .push()
        .set({
          nombre: 'Mantenimiento',
          monitor: 'operativo',
          um: '%',
          periodo: 'A',
        });
    },
    obtenerIndicadores() {
      const vueInstance = this;
      firebase
        .database()
        .ref('indicadores')
        .once('value', (snapshot) => {
          const indicadoresAutocomplete = {};

          snapshot.forEach((indicadorfb) => {
            indicadoresAutocomplete[indicadorfb.val().nombre] = null;
            vueInstance.indicadoresAutocompleteKeys[indicadorfb.val().nombre] =
              indicadorfb.key;
          });
          M.Autocomplete.init(vueInstance.$refs.autocompleteIndicadores, {
            data: indicadoresAutocomplete,
            onAutocomplete(selected) {
              vueInstance.indicadorSeleccionado =
                vueInstance.indicadoresAutocompleteKeys[selected];
              vueInstance.indicadorSeleccionadoNombre = selected;
            },
          });
        });
    },

    calcularFechas(fecha, periodo) {
      const fechaInput = moment(fecha);
      console.log(fechaInput, 'exponencial');
      switch (periodo) {
        case 'W':
          this.firstdayLong = fechaInput
            .startOf('isoWeek')
            .add(-2, 'day')
            .valueOf();
          this.firstday = fechaInput
            .startOf('isoWeek')
            .add(-2, 'day')
            .format('YYYY-MM-DD');
          this.lastdayLong = fechaInput
            .endOf('isoWeek')
            .add(1, 'week')
            .add(-2, 'day')
            .valueOf();
          this.lastday = fechaInput
            .endOf('isoWeek')
            .add(1, 'week')
            .add(-2, 'day')
            .format('YYYY-MM-DD');
          console.log(firstday, lastday);

          break;
        case 'M':
          this.firstdayLong = new Date(
            fechaInput.toDate().getFullYear(),
            fechaInput.toDate().getMonth(),
            1,
          ).getTime();
          this.lastdayLong = new Date(
            fechaInput.toDate().getFullYear(),
            fechaInput.toDate().getMonth() + 1,
            0,
          ).getTime();
          var first = new Date(this.firstdayLong).toLocaleDateString();
          var last = new Date(this.lastdayLong).toLocaleDateString();
          this.firstday = new Date(first).yyyymmdd();
          this.lastday = moment(this.lastdayLong).format('YYYY-MM-DD');
          break;
        case 'D':
          this.firstdayLong = new Date(fechaInput.toDate()).getTime();
          this.lastdayLong = new Date(fechaInput.toDate()).getTime();
          this.firstday = new Date(fechaInput).yyyymmdd();
          this.lastday = new Date(fechaInput).yyyymmdd();

          break;
        case 'A':
          var firstday = new Date(
            fechaInput.toDate().getFullYear(),
            fechaInput.getMonth(),
            1,
          );
          this.firstdayLong = firstday.getTime();
          var lastday = new Date(fechaInput.toDate()).toLocaleDateString();
          this.lastdayLong = lastday.getTime();
          this.firstday = firstday.yyyymmdd();
          this.lastday = new Date(fechaInput).yyyymmdd();
          break;
      }
    },
  },
  watch: {
    fecha(value) {
      this.calcularFechas(value, this.periodo);
    },
    periodo(value) {
      this.calcularFechas(this.fecha, value);
    },
  },
  created() {
    // this.insertarIndicador();
    this.obtenerIndicadores();
    this.obtenerMetas();
  },
};
</script>

<style scoped>
</style>
